const COMPONENT_TYPE = {
  contentSectionListCard: 'contentSectionListCard',
  textBannerSmall: 'textBannerSmall',
  priceBlock: 'priceBlock',
  stickyButton: 'stickyButton',
};

export default COMPONENT_TYPE;
